// ================================================================
//  DoctorCar — Sistema de perfiles y permisos
//  Importar este archivo en cualquier componente que necesite
//  verificar acceso o construir la navegación.
// ================================================================

// Perfiles disponibles (guardados en Firestore: usuarios/{uid}.rol)
export const ROLES = {
    BASICO: 'basico',
    INTERMEDIO: 'intermedio',
    COMPLETO: 'completo',
    SUPERADMIN: 'superadmin',
};

// Etiquetas y colores para mostrar en UI
export const ROLE_META = {
    basico: {
        label: 'Básico',
        color: '#6b7280',
        bg: '#f3f4f6',
        border: '#e5e7eb',
    },
    intermedio: {
        label: 'Intermedio',
        color: '#0891b2',
        bg: '#e0f2fe',
        border: '#7dd3fc',
    },
    completo: {
        label: 'Completo',
        color: '#7c3aed',
        bg: '#ede9fe',
        border: '#c4b5fd',
    },
    superadmin: {
        label: 'Super Admin',
        color: '#92400e',
        bg: '#fef3c7',
        border: '#fde68a',
    },
};

// Rutas protegidas y qué perfiles tienen acceso
// Orden: define también el orden del menú en el Sidebar
export const ROUTE_PERMISSIONS = [
    {
        key: 'catalogo',
        path: '/modelos',
        label: 'Catálogo',
        icon: 'LayoutGrid',
        section: 'Mercado',
        roles: ['basico', 'intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'novedades',
        path: '/novedades',
        label: 'Novedades',
        icon: 'TrendingUp',
        section: 'Mercado',
        roles: ['basico', 'intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'usados',
        path: '/usados',
        label: 'Autos usados',
        icon: 'Car',
        section: 'Mercado',
        roles: ['intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'inteligencia',
        path: '/inteligencia',
        label: 'Market Intelligence',
        icon: 'Brain',
        section: 'Inteligencia',
        roles: ['completo', 'superadmin'],
    },
    {
        key: 'asesor',
        path: '/asesor',
        label: 'Asistente IA',
        icon: 'Bot',
        section: 'Inteligencia',
        badge: 'Beta',
        // Accesible desde intermedio (modo Asesor de compra); el modo
        // Product Manager se muestra solo si el rol es completo/superadmin
        // (gateado dentro del propio componente, ver AsesorAuto.js).
        roles: ['intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'listas',
        path: '/mis-listas',
        label: 'Mis proyectos',
        icon: 'Heart',
        section: 'Mi cuenta',
        roles: ['intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'perfil',
        path: '/perfil',
        label: 'Mi perfil',
        icon: 'User',
        section: 'Mi cuenta',
        roles: ['basico', 'intermedio', 'completo', 'superadmin'],
    },
    {
        key: 'mantenedor',
        path: '/admin/mantenedor',
        label: 'Mantenedor',
        icon: 'Wrench',
        section: 'Admin',
        roles: ['superadmin'],
    },
];

// Helper: ¿tiene este rol acceso a una ruta?
export function canAccess(rol, routeKey) {
    const route = ROUTE_PERMISSIONS.find(r => r.key === routeKey);
    if (!route) return false;
    return route.roles.includes(rol);
}

// Helper: rutas accesibles para un rol
export function routesForRole(rol) {
    return ROUTE_PERMISSIONS.filter(r => r.roles.includes(rol));
}

// Helper: la primera ruta accesible (para redirect post-login)
export function defaultRouteForRole(rol) {
    const routes = routesForRole(rol);
    return routes.length ? routes[0].path : '/perfil';
}